import { generateSpectrum } from 'spectrum-generator';
import { convertWidthToPPM } from './util/convertWidthToPPM';
export function peaksToXY(peaks, options) {
    const { frequency, nbPoints = 1024, shape } = options;
    const newPeaks = convertWidthToPPM(peaks, { frequency });
    return generateSpectrum(newPeaks, {
        generator: {
            ...getFromTo(newPeaks, options),
            nbPoints,
            shape,
        },
    });
}
function getFromTo(newPeaks, options) {
    if ('to' in options && 'from' in options) {
        return {
            from: options.from,
            to: options.to,
        };
    }
    newPeaks.sort((a, b) => a.x - b.x);
    const firstPeak = newPeaks[0];
    const lastPeak = newPeaks[newPeaks.length - 1];
    const { from = firstPeak.x - firstPeak.width * 2, to = lastPeak.x + lastPeak.width * 2, } = options;
    return {
        from,
        to,
    };
}
//# sourceMappingURL=peaksToXY.js.map